import angular from 'angular';
import application from 'application/application';

const controller = 'ProcessListController';

application.controller(controller, [
	'$scope',
	'$rootScope',
	'$http',
	'$stateParams',
	'API',
	'helper',
	'$state',
	'authentication',
	'$timeout',
	'$location',
	'$filter',
	'permissions',
	(
		$scope,
		$rootScope,
		$http,
		$stateParams,
		API,
		helper,
		$state,
		authentication,
		$timeout,
		$location,
		$filter,
		permissions
	) => {
		$rootScope.treatCompoments();

		$scope.stateParams = $stateParams;

		$scope.userClient = authentication.getUserData('nome');

		$rootScope.pageSelected = 'pageProcess';

		$scope.popoverMax = false;

		$rootScope.initProcess = false;

		$scope.groupUserSelected = localStorage.getItem('__groupSelected__');

		if ($scope.groupUserSelected == null || $scope.groupUserSelected == 'false')
			$scope.groupUserSelected = false;

		$scope.groupData = JSON.parse(localStorage.getItem('__groupUserData__'));

		$scope.filter = $.extend({}, $stateParams);

		const { processo, tribunal, fonte, pasta, nomePasta } = $stateParams;

		$scope.hasFilters =
			!!processo || !!tribunal || !!fonte || !!pasta || !!nomePasta;

		$scope.allProcess = helper
			.responseStore()
			.setCurrentPage(1)
			.setItemsPerPage(50);

		$scope.quantityPerPage = 20;

		// $scope.courts = helper.responseStore();
		// $scope.fonts = helper.responseStore();

		$scope.search = $stateParams.nomePasta;

		$scope.onInit = () => {
			if (
				$scope.processSelected &&
				$scope.processSelected.length > 0 &&
				!(
					($scope.filter && $scope.filter.processo) ||
					($scope.filter && $scope.filter.pasta)
				)
			) {
				$scope.processSelected = [];
			}
		};

		$scope.recordParametersUsers = async () => {
			const userParamsSession = sessionStorage.getItem('parametros-usuarios');

			let dataParameterUsers = null;

			if (
				userParamsSession &&
				userParamsSession != undefined &&
				userParamsSession != 'undefined'
			) {
				dataParameterUsers = JSON.parse(userParamsSession);
			}

			let record = dataParameterUsers;

			if (record) {
				$scope.parameterUsers = record;

				$scope.idQtdItensPagina = $scope.parameterUsers.idParamUsuarioProdAdv;
				// $scope.quantityPerPage = $scope.parameterUsers.qtdRegistroMovPorPagina
				// 	? $scope.parameterUsers.qtdRegistroMovPorPagina
				// 	: 20;

				return;
			}

			await $http({
				...helper.http(API.parametersUsers, 'GET'),
				params: {
					...helper.httpFields(['*'])
				}
			}).then(({ data: { itens } }) => {
				if (itens.length) {
					$scope.parameterUsers = itens[0];
					$scope.parameterUsers.naoTipo = false;
					$scope.parameterUsers.idTipoVisualizacao = itens[0].idTipoVisualizacao
						? itens[0].idTipoVisualizacao
						: -1;
					itens[0];
					$scope.parameterUsers.qtdRegistroMovPorPagina = itens[0]
						.qtdRegistroMovPorPagina
						? itens[0].qtdRegistroMovPorPagina
						: 20;
				} else {
					$scope.parameterUsers = {
						qtdRegistroMovPorPagina: 20,
						idTipoVisualizacao: -1,
						exibirInfo: true,
						naoTipo: true
					};
				}

				$scope.idQtdItensPagina = $scope.parameterUsers.idParamUsuarioProdAdv;
				// $scope.quantityPerPage = $scope.parameterUsers.qtdRegistroMovPorPagina
				// 	? $scope.parameterUsers.qtdRegistroMovPorPagina
				// 	: 20;

				sessionStorage.setItem(
					'parametros-usuarios',
					JSON.stringify($scope.parameterUsers)
				);
			});
		};

		// const queryConvert = () => {
		// 	var queryStr = window.location.search,
		// 		queryArr = queryStr.replace('?', '').split('&'),
		// 		queryParams = [];

		// 	for (var q = 0, qArrLength = queryArr.length; q < qArrLength; q++) {
		// 		var qArr = queryArr[q].split('='),
		// 			obj = {
		// 				key: qArr[0],
		// 				value: qArr[1] ? qArr[1].replace(/%20/g, ' ') : qArr[1]
		// 			};

		// 		queryParams.push(obj);
		// 	}

		// 	return queryParams;
		// };

		// $scope.updateQuantityPerPage = quantityPerPage => {
		// 	let filters = {};

		// 	queryConvert().map(filter => (filters[filter.key] = filter.value));

		// 	const userParamsSession = sessionStorage.getItem('parametros-usuarios');

		// 	let dataParameterUsers = null;

		// 	if (
		// 		userParamsSession &&
		// 		userParamsSession != undefined &&
		// 		userParamsSession != 'undefined'
		// 	) {
		// 		dataParameterUsers = JSON.parse(userParamsSession);
		// 	}

		// 	let record = dataParameterUsers;

		// 	let paramUsuarioProdAdv = 0;

		// 	if (record && record.idParamUsuarioProdAdv) {
		// 		paramUsuarioProdAdv = record.idParamUsuarioProdAdv;
		// 	}

		// 	$scope.idQtdItensPagina = $scope.idQtdItensPagina
		// 		? $scope.idQtdItensPagina
		// 		: paramUsuarioProdAdv;

		// 	let method = $scope.idQtdItensPagina ? 'PUT' : 'POST';

		// 	$scope.quantityPerPage = quantityPerPage;

		// 	$http({
		// 		...helper.http(API.parametersUsers, method),
		// 		data: {
		// 			itens: [
		// 				{
		// 					id: record.idParamUsuarioProdAdv,
		// 					qtdRegistroMovPorPagina: quantityPerPage || 20
		// 				}
		// 			]
		// 		},
		// 		messageOverride: {
		// 			success() {},
		// 			error() {}
		// 		}
		// 	}).then(() => {
		// 		sessionStorage.setItem('__pageMovements__', 1);

		// 		record.qtdRegistroMovPorPagina = quantityPerPage || 20;

		// 		sessionStorage.setItem('parametros-usuarios', JSON.stringify(record));

		// 		if (
		// 			$location &&
		// 			$location.search() &&
		// 			$location.search().paginaAtual != 1
		// 		) {
		// 			$location.search({ paginaAtual: 1 });
		// 		} else {
		// 			$location.search({});
		// 		}
		// 	});
		// };

		$scope.filterFolder = search => {
			if (!search || $scope.viewPopover()) return;

			$scope.filter.pasta = undefined;
			$scope.filter.processo = undefined;

			$scope.historySearch = search;
			search = search.replace(/[.,\/\-_]/g, '');

			$scope.storeSearchHistoryItem($scope.historySearch);

			$state.go($state.current.name, {
				...$scope.filter,
				nomePasta: search
			});
		};

		$scope.clearSearchFilter = () => {
			$scope.search = null;
			$scope.filter.nomePasta = undefined;

			$state.go($state.current.name, $scope.filter);
		};

		$scope.storageProcessPaste = pastaId => {
			sessionStorage.setItem('__processPaste__', true);
			$rootScope.deleteAllOfCount();

			const params = {
				pasta: pastaId
			};

			$state.transitionTo('root.default.movements.list4', params, {
				inherit: false,
				reload: 'root.default.movements.list4'
			});
			// $rootScope.toggleCollapse('process', 'keyword');
		};

		$scope.storeSearchHistoryItem = term => {
			let searchHistory =
				JSON.parse(localStorage.getItem('__processSearchHistory__')) || [];

			if (searchHistory) {
				const hasItemHistory = searchHistory.some(item => item === term);

				if (hasItemHistory) searchHistory.sort(a => (a === term ? -1 : 1));
				else {
					searchHistory.unshift(term);

					if (searchHistory.length > 5) searchHistory.pop();
				}
			} else searchHistory.unshift(term);

			localStorage.setItem(
				'__processSearchHistory__',
				JSON.stringify(searchHistory.slice(0, 5))
			);
		};

		$scope.searchFocus = false;

		$scope.history = [];

		$scope.toggleFocus = (trigger = false) => {
			$scope.history = trigger
				? JSON.parse(localStorage.getItem('__processSearchHistory__')) || []
				: [];
		};

		$scope.loseFocus = () => {
			$timeout(() => {
				$scope.toggleFocus(false);
			}, 250);
		};

		$scope.handlerChangeFilterReporter = term => {
			$timeout(() => {
				$scope.searchFocus = false;

				$scope.search = term;

				$scope.loseFocus();

				setTimeout(() => {
					$scope.filterFolder(term);
				}, 500);
			});
		};

		$scope.findProcess = () => {
			if (!$stateParams.processo || !$stateParams.pasta) return;

			$http({
				...helper.http(API.briefcase, 'GET'),
				method: 'GET',
				params: {
					...helper.httpFields(['id', 'nome']),
					ids: $stateParams.pasta,
					registrosPorPagina: 1,
					paginaAtual: 1,
					IdGrupoUsuarios: $scope.groupData && $scope.groupData.idGrupo
				}
			}).then(response => {
				$scope.processSelected = response.data.itens;
			});
		};

		$scope.findProcess();

		$scope.loaded = false;

		$scope.getAllProcess = responseStore => {
			responseStore.setLoading();

			$scope.goSubmenuProcess(true);

			$scope.recordParametersUsers();

			if (
				!permissions.has('createProcess') &&
				!permissions.has('createMovements') &&
				!permissions.has('createManualMovements')
			) {
				$scope.processMovements.setReady(true);

				$state.transitionTo('root.default.initial', {
					inherit: false,
					reload: true
				});

				return;
			}

			$http({
				...helper.http(API.briefcase, 'processes'),
				method: 'GET',
				params: {
					campos: '*',
					registrosPorPagina: $scope.quantityPerPage,
					ordenacao: $rootScope.order + $rootScope.orderField,
					idProcesso: $stateParams.processo,
					paginaAtual: $stateParams.paginaAtual ? $stateParams.paginaAtual : 1,
					NomePasta: $scope.search,
					idGrupo:
						$scope.groupUserSelected && $scope.groupData
							? $scope.groupData.idGrupo
							: null
				}
			})
				.then(response => {
					const {
						paginaAtual,
						paginaTotal,
						registrosTotal
					} = response.data.paginacao;

					$scope.paginaAtual = paginaAtual;
					$scope.paginaTotal = paginaTotal;
					$scope.registrosTotal = registrosTotal;
					$scope.hasNext = $scope.paginaAtual < $scope.paginaTotal;

					$scope.loaded = true;

					$scope.goSubmenuProcess(false, response);

					responseStore.setItems(response.data.itens);

					$rootScope.initProcess = false;
				})

				.finally(() => responseStore.setNotLoading());
		};

		$scope.goSubmenuProcess = (iNit, response) => {
			if (iNit) {
				if (
					$scope.allProcess.hasNotItems() &&
					($stateParams.paginaAtual == '1' || !$stateParams.paginaAtual)
				) {
					$rootScope.initProcess = true;
					$rootScope.submenuProcess(true);
				}
			} else {
				if (response) var respo = helper.cloneSimpleObject(response);

				if (
					$scope.allProcess.hasNotItems() &&
					($stateParams.paginaAtual == '1' || !$stateParams.paginaAtual)
				) {
					$rootScope.submenuProcess(iNit, respo);
				}
			}
		};

		$scope.customSearch = text => text.replace(/[.,\/\-_]/g, '');

		$scope.hasProcessPrevPage = () =>
			($stateParams.paginaAtual ? +$stateParams.paginaAtual : 1) > 1;

		$scope.getAllProcess($scope.allProcess);

		$scope.recordProcessPaginate = direction => {
			let page;

			if (direction == 'next')
				page = $stateParams.paginaAtual
					? Number($stateParams.paginaAtual) + 1
					: 2;
			else if (direction == 'prev')
				page = $stateParams.paginaAtual
					? Number($stateParams.paginaAtual) - 1
					: 1;
			else if (direction == 'last') page = $scope.paginaTotal;
			else page = 1;

			$state.go(
				$state.current.name,
				{
					...$scope.filter,
					paginaAtual: page
				},
				{
					inherit: false,
					reload: 'root.default.movements.processList'
				}
			);
		};

		$scope.clearFilter = function(f, arr) {
			arr.map(item => {
				f[item] = undefined;
			});

			$scope.filterProcess($scope.filter);
		};

		$scope.filterProcess = filters => {
			filters.paginaAtual = 1;
			if (!filters.processo) filters['pasta'] = null;
			if ($stateParams.processo !== filters.processo)
				filters['tribunal'] = null;
			if ($stateParams.tribunal !== filters.tribunal) filters['fonte'] = null;

			$state.go($state.current.name, filters);
		};

		$scope.changeProcessFilter = filters => {
			setTimeout(() => {
				filters.processo =
					$('#btnFilterByProcess').attr('ng-custom-model') ||
					$('#btnFilterByProcessSelected').attr('ng-custom-model');
				filters.pasta =
					$('#btnFilterByProcess').attr('ng-process-value') ||
					$('#btnFilterByProcessSelected').attr('ng-process-value');

				$scope.search = null;
				filters.nomePasta = undefined;

				$scope.filterProcess(filters);
			}, 100);
		};

		$scope.changeProcessFilterByName = filters => {
			setTimeout(() => {
				filters.processo =
					$('#btnFilterByProcess').attr('ng-custom-model') ||
					$('#btnFilterByProcessSelected').attr('ng-custom-model');
				filters.pasta =
					$('#btnFilterByProcess').attr('ng-process-value') ||
					$('#btnFilterByProcessSelected').attr('ng-process-value');

				if (filters.processo === filters.pasta) {
					filters.nomePasta = filters.processo;
					filters.processo = undefined;
					filters.pasta = undefined;
				} else {
					filters.nomePasta = undefined;
				}
				$scope.filterProcess(filters);
			}, 100);
		};

		$scope.changeOrder = order => {
			if (order === $rootScope.orderField) {
				$rootScope.order = $rootScope.order === '+' ? '-' : '+';
			} else {
				$rootScope.orderField = order;

				$rootScope.order = '-';
			}

			$scope.getAllProcess($scope.allProcess);

			$rootScope.changeProcessOrder();
		};

		$scope.cadastrarProcesso = () => (window.location = '/cadastrar-processos');

		$scope.addAutomaticProcesses = () =>
			(window.location = '/cadastrar-processos-automaticos');

		$scope.openAddPprocess = () => {
			$('#modalAddProcess').modal('show');
		};

		$scope.checkPermissions = () => {
			let params;

			if ($scope.groupUserSelected == 'true') {
				params = {
					idgrupousuarios: $scope.groupData.idGrupo || null
				};
			}

			permissions.has('recordSchedule') &&
				$http({
					...helper.http(API.permissionsMovimentacoes, 'GET'),
					method: 'GET',
					params
				}).then(({ data }) => {
					if (data.itens && data.itens.length > 0) {
						$scope.firstAccess = data.itens[0].primeiroAcesso;
					} else {
						$scope.firstAccess = false;
					}

					$scope.firstAccess && $('#modalPermissions').modal('show');

					$scope.permissionsData = data.itens[0];

					$scope.permissionsData.idUsuarioCliente =
						data.itens[0].idUsuarioCliente || 0;

					if (data.itens[0].primeiroAcesso) $scope.hasAllowed = false;
					else {
						$scope.hasAllowed = $scope.permissionsData.flAtivo ? true : false;
					}
				});
		};

		$('#modalPermissions').on('hidden.bs.modal', () => {
			if ($scope.firstAccess && !$('#inputPermissionsModal')[0].checked)
				$scope.changePermissions(false);
		});

		$scope.changePermissions = parameter => {
			let method =
				$scope.firstAccess || !$scope.permissionsData ? 'POST' : 'PUT';
			let toggle = !!parameter
				? parameter
				: $('#inputPermissionsModal')[0].checked;

			let data;
			let params;

			if (method == 'POST')
				data = {
					idUsuarioCliente: $scope.groupUserSelected == 'true' ? null : 0,
					flAtivo: toggle,
					idgrupousuarios: $scope.groupData
						? $scope.groupData.idGrupo || null
						: null
				};
			else if (method == 'PUT')
				params = {
					id: $scope.permissionsData.id,
					idsituacao: toggle,
					idgrupousuarios: $scope.groupData
						? $scope.groupData.idGrupo || null
						: null
				};

			permissions.has('recordSchedule') &&
				$http({
					...helper.http(API.permissionsMovimentacoes, method),
					method,
					data,
					params,
					messageOverride: {
						success() {},
						error() {}
					}
				}).then(({ data }) => {
					if (method == 'POST') {
						$scope.firstAccess = data.itens[0].primeiroAcesso || false;

						$scope.permissionsData = data.itens[0];

						$scope.permissionsData.idUsuarioCliente =
							data.itens[0].idUsuarioCliente || 0;
					}
				});
		};

		$scope.checkPermissions();
		$scope.recordParametersUsers();

		$scope.openModal = id => {
			id && $(id).modal('show');
		};

		$scope.viewPopover = () => {
			let element = document.getElementById('search-input-custom');

			if (!element) return false; // Evita erro caso o elemento não exista

			let value = element.value || '';

			$scope.popoverMax = value.length >= 301;

			// Adiciona ou remove a classe de erro dependendo do valor
			if ($scope.popoverMax) {
				angular.element(element).addClass('search__input-invalid');
			} else {
				angular.element(element).removeClass('search__input-invalid');
			}

			return $scope.popoverMax;
		};

		$scope.countDigits = value => String(value || '').replace(/\D/g, '').length;

		$scope.cnjAuto = value => {
			if (value === null || value === undefined || value === '') return '';

			const digits = String(value).replace(/\D/g, '');

			if (!digits.length) return String(value); // texto normal (ex.: nome de pasta)

			// 20 dígitos -> usa o filtro antigo (já existente) :contentReference[oaicite:1]{index=1}
			if (digits.length === 20) return $filter('formatToCNJ')(digits);

			// qualquer quantidade de dígitos -> usa a máscara nova (padStart+mask)
			return $filter('maskToCNJ')(digits);
		};

		$scope.onInit();
	}
]);

export default controller;
